<app-main-menu></app-main-menu>
<div class="content">
    <p-panel styleClass="margin-top-10">
        <ng-template pTemplate="icons">
            <button pButton pRipple class="p-panel-header-icon p-link" (click)="homeUrlNav()" icon="pi pi-home">
            </button>
        </ng-template>
        <ng-template pTemplate="header">
            QUẢN LÝ NGƯỜI YÊU CẦU
        </ng-template>
        <div class="card">
            <form [formGroup]="searchForm" (submit)="getAllNYC()">
                <div class="p-formgroup-inline">

                    <div class="p-field">
                        <label for="timkiem" class="p-sr-only">Tìm kiếm</label>
                        <input id="timkiem" type="text" pInputText placeholder="Tìm kiếm" formControlName="searchValue">
                    </div>
                    <div class="p-field">
                        <button pButton type="submit" icon="pi pi-search" label="Tìm"></button>
                    </div>

                </div>
            </form>
            <p-table [paginator]="true" [rows]="pageSize" [totalRecords]="totalRecords" [loading]="loading"
                [lazy]="true" [rowsPerPageOptions]="[10,25,50]" [value]="data" [(first)]="pageNumber"
                styleClass="p-datatable-sm" (onLazyLoad)="getNYC($event)">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Bên tham gia</th>
                        <th>Địa chỉ</th>
                        <th style="width: 150px; text-align: center;">#</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-data>
                    <tr>
                        <!-- <td>{{data.id}}</td> -->
                        <td>{{data.benthamgia}}</td>
                        <td>{{data.diachi}}</td>
                        <td>
                            <button pButton pRipple type="button" icon="pi pi-pencil"
                                class="p-button-rounded p-button-outlined" (click)="showEditNYC(data.id)"></button>
                            &nbsp;
                            <button pButton pRipple type="button" icon="pi pi-trash"
                                class="p-button-rounded p-button-outlined" (click)="delete(data.id)"></button>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="paginatorleft">
                    <p-button type="button" icon="pi pi-plus" styleClass="p-button-text" (onClick)="showAddNYC()">
                    </p-button>
                </ng-template>
                <ng-template pTemplate="paginatorright">
                    <p-button type="button" icon="pi pi-home" styleClass="p-button-text" (onClick)="homeUrlNav()">
                    </p-button>
                </ng-template>
            </p-table>
        </div>
    </p-panel>
</div>

<form novalidate [formGroup]="infoFormGroup">
    <p-dialog [(visible)]="nguoiYeuCauFlag" [draggable]="true" [style]="{width: '30vw'}" [modal]="true"
        [position]="position">
        <ng-template pTemplate="header">
            <h3>Thông tin người yêu cầu</h3>
        </ng-template>
        <div class="p-fluid">
            <div class="p-field">
                <label for="tt_benA">Bên tham gia</label>
                <textarea pInputTextarea formControlName="benthamgia" [rows]="5"></textarea>
            </div>
            <div class="p-field">
                <label for="tt_benA_diaChi">Địa chỉ</label>
                <textarea pInputTextarea formControlName="diachi" [rows]="5"></textarea>
            </div>
        </div>
        <p-footer>
            <button pButton pRipple type="button" label="Thêm/Sửa" (click)="action()"
                class="p-button-raised p-button-text"><i class="pi pi-save"></i>&nbsp;</button>
        </p-footer>
    </p-dialog>
</form>

<p-toast position="top-right"></p-toast>